import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SmallModalTemplate from 'src/components/SmallModalTemplate';

import { I18NextNS } from 'src/models/Language.model';

export type ExamCancelledModalProps = {
  show: boolean;
  onBackToOrders: () => void;
};

export default function ExamCancelledModal({
  show,
  onBackToOrders,
}: ExamCancelledModalProps) {
  const { t } = useTranslation(I18NextNS.PAGES);

  return (
    <SmallModalTemplate
      show={show}
      onHide={onBackToOrders}
      iconWrapperClassName="bg-success-subtle"
      data-test="exam-cancelled"
      icon={
        <FontAwesomeIcon icon={faCheck} className="text-success" size="sm" />
      }
      title={t('newExam.examCancelled.title')}
      description={t('newExam.examCancelled.description')}
      rightButton={
        <Button
          variant="outline-gray-500"
          className="clear-exam-button"
          onClick={onBackToOrders}
          data-track="exam.analyzing-modal.exam-cancelled-back-to-orders"
          data-test="analyzing-modal-exam-cancelled-back-to-orders"
          data-observe
        >
          {t('newExam.examCancelled.backToOrders')}
        </Button>
      }
    />
  );
}
